import { Pause, ShieldAlert } from "lucide-react";
import { useGameStore } from "../../store/gameStore";

// Heads-up banner telling players WHY their actions (movement, rolls, doors) are being
// rejected server-side — either the GM hit Pause, or "GM Must Be Here" is on for this
// Campaign scene and the GM isn't currently connected. Free Roam always stays exempt.
export default function GameLockBanner({ game, isGm, freeRoamEnabled }) {
  const gmOnline = useGameStore((s) => s.gm_online);
  if (isGm) return null;

  if (game.paused) {
    return (
      <div data-testid="game-lock-banner-paused" className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 px-5 py-2.5 rounded-full bg-black/80 backdrop-blur-2xl border border-[#D90429]/50">
        <Pause className="w-4 h-4 text-[#D90429]" />
        <span className="text-xs uppercase tracking-widest text-[#f1e0c5]">The GM has paused the game</span>
      </div>
    );
  }

  if (game.require_gm_present && !freeRoamEnabled && !gmOnline) {
    return (
      <div data-testid="game-lock-banner-waiting-gm" className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 px-5 py-2.5 rounded-full bg-black/80 backdrop-blur-2xl border border-[#D4AF37]/50">
        <ShieldAlert className="w-4 h-4 text-[#D4AF37]" />
        <span className="text-xs uppercase tracking-widest text-[#f1e0c5]">Waiting for the GM to join before you can act here</span>
      </div>
    );
  }

  return null;
}
